import 'css-chunksrc/client/scenes/calendar/monthlyView/styles.scss';export default {
  "labels": "_labels_vvy6l_1",
  "dayName": "_dayName_vvy6l_7"
};